import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useTranslation } from 'react-i18next';
import CustomTooltip from './CustomTooltip';

export interface ChartDataItem {
    date: string;
    new: number;
    newNights: number;
    changed: number;
    changedNights: number;
    cancelled: number;
    cancelledNights: number;
}

const SortedContainer = ({ sortedData }: { sortedData: ChartDataItem[] }) => {
    const { t } = useTranslation();
    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={sortedData}
                barGap={8}
                barSize={20}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                <XAxis
                    dataKey="date"
                    axisLine={false}
                    tickLine={false}
                    fontSize={12}
                    tickFormatter={(value) => value.split('.').slice(0, 2).join('.')}
                    padding={{ left: 10, right: 10 }}
                    interval={0}
                />
                <YAxis
                    axisLine={false}
                    tickLine={false}
                    fontSize={12}
                    width={50}
                />
                <Tooltip content={<CustomTooltip />} />
                <Legend
                    verticalAlign="top"
                    height={36}
                    iconType="circle"
                    iconSize={8}
                />
                <Bar
                    dataKey="new"
                    fill="#52c41a"
                    name={`${t('dashboard.new')} ${t('dashboard.reservations')}`}
                    radius={[4, 4, 0, 0]}
                />
                <Bar
                    dataKey="changed"
                    fill="#faad14"
                    name={`${t('dashboard.changed')} ${t('dashboard.reservations')}`}
                    radius={[4, 4, 0, 0]}
                />
                <Bar
                    dataKey="cancelled"
                    fill="#ff4d4f"
                    name={`${t('dashboard.cancelled')} ${t('dashboard.reservations')}`}
                    radius={[4, 4, 0, 0]}
                />
            </BarChart>
        </ResponsiveContainer>
    )
}

export default SortedContainer